<p-confirmDialog key="sstmain" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="sstmaindoublecheck" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Search Options-->
<div class="SearchOptions">
	<label>School:</label>
	<caass-schoolselector [ShowAll]="true" [Disabled]="IsLoading() == true"></caass-schoolselector>

	<label>Facility:</label>
	<p-dropdown
		style="margin-left: 5px"
		[disabled]="IsLoading() == true"
		[options]="lstFacility"
		[(ngModel)]="SelectedFacility"
		(ngModelChange)="onFacilityChange($event)"
		optionLabel="FacilityFullName"
		[filter]="true"
		filterBy="FacilityFullName"
		[showClear]="false"
		placeholder="Select a Facility"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="SelectedFacility">
				<div class="form-control NoBorder" style="text-align: left">{{ SelectedFacility.FacilityFullName }}</div>
			</div>
		</ng-template>
		<ng-template let-FacilityItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">{{ FacilityItem.FacilityFullName }}</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Active:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOption" [(ngModel)]="ActiveOption" (ngModelChange)="onActiveOptionChange($event)">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstActive" [ngValue]="o.ID">{{ o.Desc }}</option>
	</select>
</div>

<!--Column Options-->
<div class="CategoryDiv">
	<div class="HeaderDiv">
		<h4 style="margin: 0px">Column Options</h4>
		<button class="btn btn-primary" style="margin: 0px" (click)="onResetColOptions()"><i class="fa fa-undo" aria-hidden="true"></i> Reset</button>
	</div>

	<div class="CategoryInnerDiv">
		<div *ngFor="let cat of lstCategory" class="CategoryListDiv">
			<div>
				<h4>{{ cat.Category }}</h4>
			</div>
			<p-listbox
				[options]="cat.lstColumns"
				[(ngModel)]="SelectedColumns"
				[metaKeySelection]="false"
				[checkbox]="true"
				[filter]="true"
				[multiple]="true"
				optionLabel="ColumnName"
				[listStyle]="{ 'max-height': '150px' }"
				[style]="{ width: '15rem' }"
			>
				<ng-template let-col pTemplate="item">
					<div class="ListItemDiv">
						<label>{{ col.ColumnName }}</label>
					</div>
				</ng-template>
			</p-listbox>
		</div>
	</div>
</div>

<!--Table-->
<div>
	<!--Menu Bar-->
	<div class="lock-to-top" style="background-color: #ffffff">
		<!--Buttons-->
		<div class="button-body flex">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

			<!--INSERT CUSTOM BUTTONS HERE-->
			<button class="btn btn-primary" style="margin-left: 5px" (click)="onUpdateAll()">Update All</button>
		</div>
	</div>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstScanStation"
			[loading]="IsLoading() == true"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedScanStations"
			dataKey="ScanStationID"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--Selected-->
					<th class="CheckCol"></th>

					<!--INSERT CUSTOM FILTERS HERE-->

					<!--ScanStation-->
					<th>
						<p-columnFilter type="text" field="ScanStation" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!------------------------------------------------>
					<!--Location-->
					<!------------------------------------------------>
					<!--SchoolFullName-->
					<th *ngIf="IsSelected('SchoolFullName')">
						<p-columnFilter field="SchoolFullName" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSchoolFullName
									[ngModel]="value"
									[options]="lstSchoolFullName"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--FacilityName-->
					<th *ngIf="IsSelected('FacilityName')">
						<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterFacilityName
									[ngModel]="value"
									[options]="lstFacilityName"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--FacilityLocationName-->
					<th *ngIf="IsSelected('FacilityLocationName')">
						<p-columnFilter field="FacilityLocationName" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterFacilityLocationName
									[ngModel]="value"
									[options]="lstFacilityLocationName"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
					<!------------------------------------------------>

					<!------------------------------------------------>
					<!--General-->
					<!------------------------------------------------>
					<!--IsDecommissionedDesc-->
					<th *ngIf="IsSelected('IsDecommissionedDesc')">
						<p-columnFilter field="IsDecommissionedDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterIsDecommissionedDesc
									[ngModel]="value"
									[options]="lstIsDecommissionedDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--DecommissionedDTDesc-->
					<th *ngIf="IsSelected('DecommissionedDTDesc')"></th>

					<!--CurrentPackageVersion-->
					<th *ngIf="IsSelected('CurrentPackageVersion')">
						<p-columnFilter field="CurrentPackageVersion" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterCurrentPackageVersion
									[ngModel]="value"
									[options]="lstCurrentPackageVersion"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SQLServerName-->
					<th *ngIf="IsSelected('SQLServerName')">
						<p-columnFilter field="SQLServerName" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSQLServerName
									[ngModel]="value"
									[options]="lstSQLServerName"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
					<!------------------------------------------------>

					<!------------------------------------------------>
					<!--Syncing-->
					<!------------------------------------------------>
					<!--SyncDownStartDT-->
					<th *ngIf="IsSelected('SyncDownStartDT')"></th>

					<!--SyncDownInterval-->
					<th *ngIf="IsSelected('SyncDownInterval')"></th>

					<!--SyncDownIntervalMinutes-->
					<th *ngIf="IsSelected('SyncDownInterval')"></th>

					<!--SyncUpInterval-->
					<th *ngIf="IsSelected('SyncUpInterval')"></th>

					<!--SyncUpIntervalMinutes-->
					<th *ngIf="IsSelected('SyncUpInterval')"></th>

					<!--IsSeverRequestRebuild-->
					<th *ngIf="IsSelected('IsSeverRequestRebuild')">
						<p-columnFilter field="IsSeverRequestRebuildDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterIsSeverRequestRebuildDesc
									[ngModel]="value"
									[options]="lstIsSeverRequestRebuildDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
					<!--LastRebuildDT-->
					<th *ngIf="IsSelected('LastRebuildDT')"></th>					
					<!------------------------------------------------>

					<!------------------------------------------------>
					<!--Computer-->
					<!------------------------------------------------>
					<!--SYS_Computer_Name-->
					<th *ngIf="IsSelected('SYS_Computer_Name')">
						<p-columnFilter type="text" field="SYS_Computer_Name" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--SYS_OS_Name-->
					<th *ngIf="IsSelected('SYS_OS_Name')">
						<p-columnFilter field="SYS_OS_Name" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSYS_OS_Name
									[ngModel]="value"
									[options]="lstSYS_OS_Name"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SYS_OS_Architecture-->
					<th *ngIf="IsSelected('SYS_OS_Architecture')">
						<p-columnFilter field="SYS_OS_Architecture" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSYS_OS_Architecture
									[ngModel]="value"
									[options]="lstSYS_OS_Architecture"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SYS_OS_Version-->
					<th *ngIf="IsSelected('SYS_OS_Version')">
						<p-columnFilter field="SYS_OS_Version" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSYS_OS_Version
									[ngModel]="value"
									[options]="lstSYS_OS_Version"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SYS_OS_SerialNumber-->
					<th *ngIf="IsSelected('SYS_OS_SerialNumber')">
						<p-columnFilter type="text" field="SYS_OS_SerialNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--SYS_OS_MemoryKilobytes-->
					<th *ngIf="IsSelected('SYS_OS_MemoryKilobytes')"></th>

					<!--SYS_CPU_ID-->
					<th *ngIf="IsSelected('SYS_CPU_ID')">
						<p-columnFilter type="text" field="SYS_CPU_ID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--SYS_CPU_Name-->
					<th *ngIf="IsSelected('SYS_CPU_Name')">
						<p-columnFilter field="SYS_CPU_Name" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSYS_CPU_Name
									[ngModel]="value"
									[options]="lstSYS_CPU_Name"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SYS_CPU_Cores_Threads-->
					<th *ngIf="IsSelected('SYS_CPU_Cores_Threads')">
						<p-columnFilter field="SYS_CPU_Cores_Threads" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSYS_CPU_Cores_Threads
									[ngModel]="value"
									[options]="lstSYS_CPU_Cores_Threads"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!------------------------------------------------>

					<!------------------------------------------------>
					<!--Station Modes-->
					<!------------------------------------------------>
					<!--EntryModeEnabledDesc-->
					<th *ngIf="IsSelected('EntryModeEnabledDesc')">
						<p-columnFilter field="EntryModeEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterEntryModeEnabledDesc
									[ngModel]="value"
									[options]="lstEntryModeEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--ExitModeEnabledDesc-->
					<th *ngIf="IsSelected('ExitModeEnabledDesc')">
						<p-columnFilter field="ExitModeEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterExitModeEnabledDesc
									[ngModel]="value"
									[options]="lstExitModeEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--MealModeEnabledDesc-->
					<th *ngIf="IsSelected('MealModeEnabledDesc')">
						<p-columnFilter field="MealModeEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterMealModeEnabledDesc
									[ngModel]="value"
									[options]="lstMealModeEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--AccessModeEnabledDesc-->
					<th *ngIf="IsSelected('AccessModeEnabledDesc')">
						<p-columnFilter field="AccessModeEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterAccessModeEnabledDesc
									[ngModel]="value"
									[options]="lstAccessModeEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--TimeStampModeEnabledDesc-->
					<th *ngIf="IsSelected('TimeStampModeEnabledDesc')">
						<p-columnFilter field="TimeStampModeEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterTimeStampModeEnabledDesc
									[ngModel]="value"
									[options]="lstTimeStampModeEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--EventModeEnabledDesc-->
					<th *ngIf="IsSelected('EventModeEnabledDesc')">
						<p-columnFilter field="EventModeEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterEventModeEnabledDesc
									[ngModel]="value"
									[options]="lstEventModeEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
					<!------------------------------------------------>

					<!------------------------------------------------>
					<!--Hardware - Printing-->
					<!------------------------------------------------>
					<!--PrinterEnabled-->
					<th *ngIf="IsSelected('PrinterEnabledDesc')">
						<p-columnFilter field="PrinterEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterPrinterEnabledDesc
									[ngModel]="value"
									[options]="lstPrinterEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--PrinterSelected-->
					<th *ngIf="IsSelected('PrinterSelected')">
						<p-columnFilter type="text" field="PrinterSelected" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
					<!------------------------------------------------>

					<!------------------------------------------------>
					<!--Hardware - Turnstile-->
					<!------------------------------------------------>
					<!--TurnstileEnabled-->
					<th *ngIf="IsSelected('TurnstileEnabledDesc')">
						<p-columnFilter field="TurnstileEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterTurnstileEnabledDesc
									[ngModel]="value"
									[options]="lstTurnstileEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--TurnstilePort-->
					<th *ngIf="IsSelected('TurnstilePort')">
						<p-columnFilter type="text" field="TurnstilePort" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--TurnstileRelayNbr-->
					<th *ngIf="IsSelected('TurnstileRelayNbr')">
						<p-columnFilter type="text" field="TurnstileRelayNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
					<!------------------------------------------------>

					<!------------------------------------------------>
					<!--Hardware-->
					<!------------------------------------------------>
					<!--LEDEnabledDesc-->
					<th *ngIf="IsSelected('LEDEnabledDesc')">
						<p-columnFilter field="LEDEnabledDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterLEDEnabledDesc
									[ngModel]="value"
									[options]="lstLEDEnabledDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--Enable4ChannelScanningDesc-->
					<th *ngIf="IsSelected('Enable4ChannelScanningDesc')">
						<p-columnFilter field="Enable4ChannelScanningDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterEnable4ChannelScanningDesc
									[ngModel]="value"
									[options]="lstEnable4ChannelScanningDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--OmniKeyOnlyDesc-->
					<th *ngIf="IsSelected('OmniKeyOnlyDesc')">
						<p-columnFilter field="OmniKeyOnlyDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterOmniKeyOnlyDesc
									[ngModel]="value"
									[options]="lstOmniKeyOnlyDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
					<!------------------------------------------------>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th class="CheckCol">
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="ScanStation">Station<p-sortIcon field="ScanStation"></p-sortIcon></th>
					<th *ngIf="IsSelected('SchoolFullName')" pSortableColumn="SchoolFullName">School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
					<th *ngIf="IsSelected('FacilityName')" pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
					<th *ngIf="IsSelected('FacilityLocationName')" pSortableColumn="FacilityLocationName">
						Location<p-sortIcon field="FacilityLocationName"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('IsDecommissionedDesc')" pSortableColumn="IsDecommissionedDesc">
						Decommissioned<p-sortIcon field="IsDecommissionedDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('DecommissionedDTDesc')" pSortableColumn="DecommissionedDT">
						Decommissioned Date<p-sortIcon field="DecommissionedDT"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('CurrentPackageVersion')" pSortableColumn="CurrentPackageVersion">
						ScanStation Version<p-sortIcon field="CurrentPackageVersion"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SQLServerName')" pSortableColumn="SQLServerName">SQL Server Name<p-sortIcon field="SQLServerName"></p-sortIcon></th>
					<th *ngIf="IsSelected('SyncDownStartDT')" pSortableColumn="SyncDownStartDT">Last Sync<p-sortIcon field="SyncDownStartDT"></p-sortIcon></th>
					<th *ngIf="IsSelected('SyncDownInterval')" pSortableColumn="SyncDownInterval">
						Sync Down Interval<p-sortIcon field="SyncDownInterval"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SyncDownInterval')" pSortableColumn="SyncDownIntervalMinutes">
						Sync Down Minutes<p-sortIcon field="SyncDownIntervalMinutes"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SyncUpInterval')" pSortableColumn="SyncUpInterval">
						Sync Up Interval<p-sortIcon field="SyncUpInterval"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SyncUpInterval')" pSortableColumn="SyncUpIntervalMinutes">
						Sync Up Minutes<p-sortIcon field="SyncUpIntervalMinutes"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('IsSeverRequestRebuild')" pSortableColumn="IsSeverRequestRebuildDesc">
						Server Requested Rebuild<p-sortIcon field="IsSeverRequestRebuildDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('LastRebuildDT')" pSortableColumn="StationRebuildDateDT">Last Rebuild<p-sortIcon field="StationRebuildDateDT"></p-sortIcon></th>					
					<th *ngIf="IsSelected('SYS_Computer_Name')" pSortableColumn="SYS_Computer_Name">
						Computer Name<p-sortIcon field="SYS_Computer_Name"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SYS_OS_Name')" pSortableColumn="SYS_OS_Name">OS<p-sortIcon field="SYS_OS_Name"></p-sortIcon></th>
					<th *ngIf="IsSelected('SYS_OS_Architecture')" pSortableColumn="SYS_OS_Architecture">
						OS Architecture<p-sortIcon field="SYS_OS_Architecture"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SYS_OS_Version')" pSortableColumn="SYS_OS_Version">
						OS Version Number<p-sortIcon field="SYS_OS_Version"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SYS_OS_SerialNumber')" pSortableColumn="SYS_OS_SerialNumber">
						OS Serial Number<p-sortIcon field="SYS_OS_SerialNumber"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SYS_OS_MemoryKilobytes')" pSortableColumn="SYS_OS_MemoryKilobytes">
						RAM in kb<p-sortIcon field="SYS_OS_MemoryKilobytes"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('SYS_CPU_ID')" pSortableColumn="SYS_CPU_ID">Processor ID<p-sortIcon field="SYS_CPU_ID"></p-sortIcon></th>
					<th *ngIf="IsSelected('SYS_CPU_Name')" pSortableColumn="SYS_CPU_Name">CPU Chip<p-sortIcon field="SYS_CPU_Name"></p-sortIcon></th>
					<th *ngIf="IsSelected('SYS_CPU_Cores_Threads')" pSortableColumn="SYS_CPU_Cores_Threads">
						Cores/Threads<p-sortIcon field="SYS_CPU_Cores_Threads"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('EntryModeEnabledDesc')" pSortableColumn="EntryModeEnabledDesc">
						Entry Mode<p-sortIcon field="EntryModeEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('ExitModeEnabledDesc')" pSortableColumn="ExitModeEnabledDesc">
						Exit Mode<p-sortIcon field="ExitModeEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('MealModeEnabledDesc')" pSortableColumn="MealModeEnabledDesc">
						Meal Mode<p-sortIcon field="MealModeEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('AccessModeEnabledDesc')" pSortableColumn="AccessModeEnabledDesc">
						Access Mode<p-sortIcon field="AccessModeEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('TimeStampModeEnabledDesc')" pSortableColumn="TimeStampModeEnabledDesc">
						Time Stamp Mode<p-sortIcon field="TimeStampModeEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('EventModeEnabledDesc')" pSortableColumn="EventModeEnabledDesc">
						Event Mode<p-sortIcon field="EventModeEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('PrinterEnabledDesc')" pSortableColumn="PrinterEnabledDesc">
						Printer Enabled<p-sortIcon field="PrinterEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('PrinterSelected')" pSortableColumn="PrinterSelected">
						Selected Printer<p-sortIcon field="PrinterSelected"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('TurnstileEnabledDesc')" pSortableColumn="TurnstileEnabledDesc">
						Turnstile Enabled<p-sortIcon field="TurnstileEnabledDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('TurnstilePort')" pSortableColumn="TurnstilePort">Turnstile Port<p-sortIcon field="TurnstilePort"></p-sortIcon></th>
					<th *ngIf="IsSelected('TurnstileRelayNbr')" pSortableColumn="TurnstileRelayNbr">
						Turnstile Relay<p-sortIcon field="TurnstileRelayNbr"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('LEDEnabledDesc')" pSortableColumn="LEDEnabledDesc">LED Enabled<p-sortIcon field="LEDEnabledDesc"></p-sortIcon></th>
					<th *ngIf="IsSelected('Enable4ChannelScanningDesc')" pSortableColumn="Enable4ChannelScanningDesc">
						4 Channel Scanning Enabled<p-sortIcon field="Enable4ChannelScanningDesc"></p-sortIcon>
					</th>
					<th *ngIf="IsSelected('OmniKeyOnlyDesc')" pSortableColumn="OmniKeyOnlyDesc">
						OmniKey Only<p-sortIcon field="OmniKeyOnlyDesc"></p-sortIcon>
					</th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-ScanStation>
				<tr [pSelectableRow]="ScanStation">
					<td class="CheckCol">
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="ScanStation" [value]="ScanStation"></p-tableCheckbox>
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.ScanStation }}
					</td>

					<td *ngIf="IsSelected('SchoolFullName')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SchoolFullName }}
					</td>

					<td *ngIf="IsSelected('FacilityName')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.FacilityName }}
					</td>

					<td *ngIf="IsSelected('FacilityLocationName')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.FacilityLocationName }}
					</td>

					<td *ngIf="IsSelected('IsDecommissionedDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input
							class="CHK"
							type="checkbox"
							[(ngModel)]="ScanStation.IsDecommissioned"
							(ngModelChange)="onUpdateDecommissioned(ScanStation, $event)"
						/>
					</td>

					<td *ngIf="IsSelected('DecommissionedDTDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.DecommissionedDTDesc }}
					</td>

					<td *ngIf="IsSelected('CurrentPackageVersion')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.CurrentPackageVersion }}
					</td>

					<td *ngIf="IsSelected('SQLServerName')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<span *ngIf="ScanStation.CanEditSQLServer == false">{{ ScanStation.SQLServerName }}</span>
						<div *ngIf="ScanStation.CanEditSQLServer == true">
							<input
								[style.color]="ScanStation.SQLServerName == 'localhost' ? 'Black' : 'Red'"
								type="text"
								[(ngModel)]="ScanStation.NewSQLServerName"
							/>
							<button
								class="btn btn-primary"
								[disabled]="ScanStation.SQLServerName == ScanStation.NewSQLServerName"
								style="padding: 2px 5px"
								(click)="onSaveSqlServerName(ScanStation)"
							>
								Save
							</button>
						</div>
					</td>

					<td *ngIf="IsSelected('SyncDownStartDT')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SyncDownStartDTDesc }}
					</td>

					<td *ngIf="IsSelected('SyncDownInterval')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SyncDownInterval }}
					</td>

					<td *ngIf="IsSelected('SyncDownInterval')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SyncDownIntervalMinutes }}
					</td>

					<td *ngIf="IsSelected('SyncUpInterval')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SyncUpInterval }}
					</td>

					<td *ngIf="IsSelected('SyncUpInterval')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SyncUpIntervalMinutes }}
					</td>

					<td *ngIf="IsSelected('IsSeverRequestRebuild')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input
							class="CHK"
							type="checkbox"
							[disabled]="ScanStation.IsDecommissioned == true"
							[(ngModel)]="ScanStation.IsSeverRequestRebuild"
							(ngModelChange)="onUpdateRebuild(ScanStation, $event)"
						/>
					</td>

					<td *ngIf="IsSelected('LastRebuildDT')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.StationRebuildDateDesc }}
					</td>
										
					<td *ngIf="IsSelected('SYS_Computer_Name')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_Computer_Name }}
					</td>

					<td *ngIf="IsSelected('SYS_OS_Name')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_OS_Name }}
					</td>

					<td *ngIf="IsSelected('SYS_OS_Architecture')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_OS_Architecture }}
					</td>

					<td *ngIf="IsSelected('SYS_OS_Version')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_OS_Version }}
					</td>

					<td *ngIf="IsSelected('SYS_OS_SerialNumber')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_OS_SerialNumber }}
					</td>

					<td *ngIf="IsSelected('SYS_OS_MemoryKilobytes')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_OS_MemoryKilobytes }}
					</td>

					<td *ngIf="IsSelected('SYS_CPU_ID')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_CPU_ID }}
					</td>

					<td *ngIf="IsSelected('SYS_CPU_Name')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_CPU_Name }}
					</td>

					<td *ngIf="IsSelected('SYS_CPU_Cores_Threads')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.SYS_CPU_Cores_Threads }}
					</td>

					<td *ngIf="IsSelected('EntryModeEnabledDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input
							class="CHK"
							type="checkbox"
							[(ngModel)]="ScanStation.EntryModeEnabled"
							(ngModelChange)="onUpdateEntryMode(ScanStation, $event)"
						/>
					</td>

					<td *ngIf="IsSelected('ExitModeEnabledDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input class="CHK" type="checkbox" [(ngModel)]="ScanStation.ExitModeEnabled" (ngModelChange)="onUpdateExitMode(ScanStation, $event)" />
					</td>

					<td *ngIf="IsSelected('MealModeEnabledDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input class="CHK" type="checkbox" [(ngModel)]="ScanStation.MealModeEnabled" (ngModelChange)="onUpdateMealMode(ScanStation, $event)" />
					</td>

					<td *ngIf="IsSelected('AccessModeEnabledDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input
							class="CHK"
							type="checkbox"
							[(ngModel)]="ScanStation.AccessModeEnabled"
							(ngModelChange)="onUpdateAccessMode(ScanStation, $event)"
						/>
					</td>

					<td *ngIf="IsSelected('TimeStampModeEnabledDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input
							class="CHK"
							type="checkbox"
							[(ngModel)]="ScanStation.TimeStampModeEnabled"
							(ngModelChange)="onUpdateTimeStampMode(ScanStation, $event)"
						/>
					</td>

					<td *ngIf="IsSelected('EventModeEnabledDesc')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						<input
							class="CHK"
							type="checkbox"
							[(ngModel)]="ScanStation.EventModeEnabled"
							(ngModelChange)="onUpdateEventMode(ScanStation, $event)"
						/>
					</td>

					<td
						*ngIf="IsSelected('PrinterEnabledDesc')"
						[style.color]="ScanStation.PrinterEnabled == true ? 'Black' : 'Red'"
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					>
						{{ ScanStation.PrinterEnabledDesc }}
					</td>

					<td *ngIf="IsSelected('PrinterSelected')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.PrinterSelected }}
					</td>

					<td
						*ngIf="IsSelected('TurnstileEnabledDesc')"
						[style.color]="ScanStation.TurnstileEnabled == true ? 'Black' : 'Red'"
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					>
						{{ ScanStation.TurnstileEnabledDesc }}
					</td>

					<td *ngIf="IsSelected('TurnstilePort')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.TurnstilePort }}
					</td>

					<td *ngIf="IsSelected('TurnstileRelayNbr')" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.TurnstileRelayNbr }}
					</td>

					<td
						*ngIf="IsSelected('LEDEnabledDesc')"
						[style.color]="ScanStation.LEDEnabled == true ? 'Black' : 'Red'"
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					>
						{{ ScanStation.LEDEnabledDesc }}
					</td>

					<td
						*ngIf="IsSelected('Enable4ChannelScanningDesc')"
						[style.color]="ScanStation.Enable4ChannelScanning == true ? 'Black' : 'Red'"
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					>
						{{ ScanStation.Enable4ChannelScanningDesc }}
					</td>

					<td
						*ngIf="IsSelected('OmniKeyOnlyDesc')"
						[style.color]="ScanStation.OmniKeyOnly == true ? 'Black' : 'Red'"
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					>
						{{ ScanStation.OmniKeyOnlyDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Error Message-->
	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
	</div>
</div>
